import React, { SVGProps } from 'react'
export const FirstDefaultCenterSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="36"
    fill="none"
    preserveAspectRatio="none"
    viewBox="0 0 74 36"
    {...props}
  >
    <path
      fill="#7F7472"
      fillRule="evenodd"
      d="M51.503 34.99c6.456 0 15.127-.06 22.497-.99v1c-7.44.939-16.047.99-22.497.99L0 35.995v-1l51.503-.007Z"
    />
    <path
      fill="#7F7472"
      d="M20.934 1.066C12.407.88 5.441 1.103 0 1.992V.98C5.54.074 12.427-.123 20.956.064c4.114.09 8.599.25 13.47.422l.551.02c5.087.18 10.592.373 16.538.517C61.101 1.255 68.357 2.552 74 3.997V5c-5.576-1.428-13.005-2.745-22.509-2.975-5.953-.144-11.463-.337-16.549-.518l-.548-.019c-4.874-.173-9.353-.332-13.46-.422Z"
    />
  </svg>
)
